document.querySelectorAll('.coast-drag-scroll').forEach((el) => {
  let isDown = false;
  let moved = false;
  let startX = 0;
  let scrollLeftStart = 0;

  el.addEventListener('pointerdown', (event) => {
    isDown = true;
    moved = false;
    el.classList.add('is-dragging');
    startX = event.pageX;
    scrollLeftStart = el.scrollLeft;
  });

  window.addEventListener('pointerup', () => {
    isDown = false;
    el.classList.remove('is-dragging');
  });

  el.addEventListener('pointerleave', () => {
    isDown = false;
    el.classList.remove('is-dragging');
  });

  el.addEventListener('pointermove', (event) => {
    if (!isDown) return;
    const delta = event.pageX - startX;
    if (Math.abs(delta) > 5) moved = true;
    el.scrollLeft = scrollLeftStart - delta;
  });

  el.addEventListener(
    'click',
    (event) => {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
});
